import { ConfigService } from './config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IChangePassword } from '../interfaces/IChangePassword';
import { IConfirmEmail } from '../interfaces/IConfirmarEmail';
import { Injectable } from '@angular/core';
import { IUser } from '../interfaces/IUser';
import { Usuario } from '../models/usuario';
import { BuscadorNC } from '../models/buscadorNC';
import { NotaCreditoCabecera } from '../models/notaCreditoCabecera';
import { TokenService } from '../utils/token.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class NCService {

  private ncServerUri: string;
  private apiUrl = environment.apiUrl;

  constructor(
    private httpCliente: HttpClient,
    private configService: ConfigService,
    private tokenService: TokenService
  ) {
    this.ncServerUri = /*this.configService.ServerURI*/this.apiUrl + '/' + this.configService.NCURI;
  }

  private getHeaders() {
    const authToken = this.tokenService.getAuthToken();
    const authTokenBearer = this.tokenService.getAuthTokenBearer();

    return new HttpHeaders({
      'Authorization': `Bearer ${authTokenBearer}`,      
      'PortalO2G' : `${authToken}`
    });
  }
  


  cPedidosRelacionados(idPais: string, idCompania: string, idSalesOrg: string, idDivision: string, nrocliente: string) {
    return this.httpCliente.get(this.ncServerUri + 'CPedidosRelacionados?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&idDivision=" + idDivision + "&nrocliente=" + nrocliente, { headers: this.getHeaders() });
  }

  cRemitos(nroPedidoOriginal: number) {
    return this.httpCliente.get(this.ncServerUri + 'CRemitos?nroPedidoOriginal=' + nroPedidoOriginal, { headers: this.getHeaders() });
  }

  cFacturas(idPais: string, idCompania: string, idSalesOrg: string, idDivision: string, nrocliente: string, nroClienteDistribuidor: string, idZonaVendedor: string, idTipoNC: string, nroPedido: number) {
    return this.httpCliente.get(this.ncServerUri + 'CFacturas?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&idDivision=" + idDivision + "&nrocliente=" + nrocliente + "&nroClienteDistribuidor=" + nroClienteDistribuidor + "&idZonaVendedor=" + idZonaVendedor + "&idTipoNC=" + idTipoNC + "&nroPedido=" + nroPedido, { headers: this.getHeaders() });
  }

  cNotaCredito(codigo: number) {
    return this.httpCliente.get(this.ncServerUri + 'CNotaCredito?codigo=' + codigo, { headers: this.getHeaders() });
  }

  cMotivosDevolucion(idPais: string, idCompania: string, idSalesOrg: string, idTipoNC: string, rol: string) {
    return this.httpCliente.get(this.ncServerUri + 'CMotivosDevolucion?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&idTipoNC=" + idTipoNC + "&rol=" + rol, { headers: this.getHeaders() });
  }

  cNotasCredito(buscador: BuscadorNC) {
    return this.httpCliente.post(this.ncServerUri + 'CNotasCredito', buscador, { headers: this.getHeaders() });
  }

  cPedidoItemsAutocompleteSearch(idPais: string, idCompania: string, idSalesOrg: string, nroFactura: string, idTipoOrdenOriginal: string, nroPedidoOriginal: number, idMoneda: string, search: string) {
    return this.httpCliente.get(this.ncServerUri + 'CPedidoItemsAutocompleteSearch?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&nroFactura=" + nroFactura + "&idTipoOrdenOriginal=" + idTipoOrdenOriginal
      + "&nroPedidoOriginal=" + nroPedidoOriginal + "&idMoneda=" + idMoneda + "&search=" + search, { headers: this.getHeaders() });
  }

  cLotesItem(idPais: string, idCompania: string, idSalesOrg: string, nroFactura: string, idTipoOrdenOriginal: string, nroPedidoOriginal: number, idProducto: string, nroRemito: string) {
    return this.httpCliente.get(this.ncServerUri + 'CLotesItem?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&nroFactura=" + nroFactura + "&idTipoOrdenOriginal=" + idTipoOrdenOriginal
      + "&nroPedidoOriginal=" + nroPedidoOriginal + "&idProducto=" + idProducto + "&nroRemito=" + nroRemito, { headers: this.getHeaders() });
  }

  cItemsFactura(idPais: string, idCompania: string, idSalesOrg: string, nroFactura: string, idTipoOrdenOriginal: string, nroPedidoOriginal: number, idProducto: string) {
    return this.httpCliente.get(this.ncServerUri + 'CItemsFactura?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&nroFactura=" + nroFactura + "&idTipoOrdenOriginal=" + idTipoOrdenOriginal
      + "&nroPedidoOriginal=" + nroPedidoOriginal + "&idProducto=" + idProducto, { headers: this.getHeaders() });
  }

  cDataItemLote(idPais: string, idCompania: string, idSalesOrg: string, nroFactura: string, idTipoOrdenOriginal: string, nroPedidoOriginal: number, idProducto: string, nroRemito: string,
    nroLinea: number, idLote: string, cantidadLote: number) {
    return this.httpCliente.get(this.ncServerUri + 'CDataItemLote?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&nroFactura=" + nroFactura + "&idTipoOrdenOriginal=" + idTipoOrdenOriginal
      + "&nroPedidoOriginal=" + nroPedidoOriginal + "&idProducto=" + idProducto + "&nroRemito=" + nroRemito + "&nroLinea=" + nroLinea + "&idLote=" + idLote + "&cantidadLote=" + cantidadLote, { headers: this.getHeaders() });
  }

  cDataItemFactura(idPais: string, idCompania: string, idSalesOrg: string, nroFactura: string, idTipoOrdenOriginal: string, nroPedidoOriginal: number, idProducto: string, itemFactura: number) {
    return this.httpCliente.get(this.ncServerUri + 'CDataItemFactura?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&nroFactura=" + nroFactura + "&idTipoOrdenOriginal=" + idTipoOrdenOriginal
      + "&nroPedidoOriginal=" + nroPedidoOriginal + "&idProducto=" + idProducto + "&itemFactura=" + itemFactura, { headers: this.getHeaders() });
  }

  amNotaCredito(ncCab: NotaCreditoCabecera) {
    return this.httpCliente.post(this.ncServerUri + 'AMNotaCredito', ncCab, { headers: this.getHeaders() });
  }
  
  aNotaCreditoItem(ncCab: NotaCreditoCabecera) {     
    return this.httpCliente.post(this.ncServerUri + 'ANotaCreditoItem', ncCab, { headers: this.getHeaders() });
  }

  bNotaCreditoItem(codigoCabecera: number, codigoItem: number) {
    return this.httpCliente.get(this.ncServerUri + 'BNotaCreditoItem?codigoCabecera=' + codigoCabecera + "&codigoItem=" + codigoItem, { headers: this.getHeaders() });
  }

  cNotaCreditoItem(codigoItem: number) {
    return this.httpCliente.get(this.ncServerUri + 'CNotaCreditoItem?codigoItem=' + codigoItem, { headers: this.getHeaders() });
  }

  mNotaCreditoItem(pvc: NotaCreditoCabecera) {
    return this.httpCliente.post(this.ncServerUri + 'MNotaCreditoItem', pvc, { headers: this.getHeaders() });
  }

  aprobarNotaCredito(nc: NotaCreditoCabecera) {
    return this.httpCliente.post(this.ncServerUri + 'AprobarNotaCredito', nc, { headers: this.getHeaders() });
  }
  rechazarNotaCredito(nc: NotaCreditoCabecera) {
    return this.httpCliente.post(this.ncServerUri + 'RechazarNotaCredito', nc, { headers: this.getHeaders() });
  }


}